import styled, { css } from 'styled-components';
import { MaxWidth } from '../../base';

const AccordionWrapper = styled.div`
  border: 1px solid ${({ theme: { colors } }) => colors.light.light};
  margin-bottom: 32px;
  padding: 20px 40px;
  border-radius: 4px;
  transition: all ease-in-out 0.2s;
  cursor: pointer;
  background-color: ${({ theme: { colors } }) => colors.light.primary};
  &:last-child {
    margin-bottom: 0;
  }
  ${props =>
    props.expanded &&
    css`
      background-color: ${({ theme: { colors } }) => colors.light.primary};
      box-shadow: 0 20px 80px 0 rgba(151, 130, 130, 0.24);
      border: 1px solid ${({ theme: { colors } }) => colors.light.primary};
    `}
  h6 {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 0;
    line-height: 26px;
  }
  ${MaxWidth.sm`
    margin-bottom: 16px;
  `}
`;

const AccordionListTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 16px);
  position: relative;
  /* h6 { font-weight: 400 }; */
  ${props =>
    props.expanded &&
    css`
      padding-bottom: 24px;
      h6 {
        font-weight: 600;
      }
      &:before {
        position: absolute;
        bottom: 0;
        content: '';
        width: calc(100% + 57px);
        border-bottom: 1px solid ${({ theme: { colors } }) => colors.gray.primary};
      }
    `}
`;

const AccordionListIcon = styled.div`
  position: absolute;
  top: 6px;
  right: -16px;
  border: solid ${({ theme: { colors } }) => colors.primary.primary};
  border-width: 0 2px 2px 0;
  display: inline-block;
  width: 10px;
  height: 10px;
  transition: all ease-in-out 0.2s;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  ${props =>
    props.expanded &&
    css`
      top: 10px;
      border-color: ${({ theme: { colors } }) => colors.gray.primary};
      transform: rotate(0deg);
      -webkit-transform: rotate(-135deg);
    `}
`;

const AccordionListDesc = styled.div`
  margin: 24px 0;
  color: ${({ theme: { colors } }) => colors.dark.light};
`;

export { AccordionWrapper, AccordionListDesc, AccordionListTitle, AccordionListIcon };
